import { render, staticRenderFns } from "./SubStatus2.vue?vue&type=template&id=d218aa6c&"
import script from "./SubStatus2.vue?vue&type=script&lang=ts&"
export * from "./SubStatus2.vue?vue&type=script&lang=ts&"
import style0 from "./SubStatus2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports